var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03166 8.77607e-07C8.58394 0.000724776 9.03107 0.449026 9.03035 1.00131L9.02249 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9.01987L9.012 15.0013C9.01128 15.5536 8.56297 16.0007 8.01069 16C7.4584 15.9993 7.01128 15.551 7.012 14.9987L7.01986 9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H7.02248L7.03035 0.998689C7.03107 0.446405 7.47938 -0.000722961 8.03166 8.77607e-07Z",
    fill: "#000F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.6c455144f3c308b0b4e6530eb9c10062.svg";
export { ForwardRef as ReactComponent };